import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "Mail"
}
const _hoisted_2 = { class: "Mail__main" }
const _hoisted_3 = {
  key: 0,
  class: "Mail__status"
}
const _hoisted_4 = { class: "Mail__circle" }
const _hoisted_5 = {
  key: 1,
  class: "Mail__status"
}
const _hoisted_6 = { class: "Mail__container" }
const _hoisted_7 = { class: "Mail__addresses Mail__section" }
const _hoisted_8 = { class: "Mail__info-row" }
const _hoisted_9 = { class: "Mail__info-row" }
const _hoisted_10 = { class: "Mail__subject Mail__section" }
const _hoisted_11 = { class: "Mail__info-row" }
const _hoisted_12 = { class: "Mail__content" }
const _hoisted_13 = {
  key: 0,
  class: "Mail__attachements"
}
const _hoisted_14 = {
  key: 2,
  class: "Mail__footer"
}

import { computed, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Mail } from "@/types";
import NavigateBack from "@/components/ds/navigate-back/NavigateBack.vue";
import { useDebounceFn } from "@vueuse/core";
import api from "@/api";
import { useUiStore } from "@/stores/ui";
import { useEmployeeStore } from "@/stores/employees";
import { useDocumentsStore } from "@/stores/documents";
import { documentToSlug } from "@/tools/document";
import MailSend from "@/components/pages/mail/MailSend.vue";
import MailAttachement from "@/components/pages/mail/MailAttachement.vue";
import MailContent from "@/components/pages/mail/MailContent.vue";
import MailSubject from "@/components/pages/mail/MailSubject.vue";
import MailReceiver from "@/components/pages/mail/MailReceiver.vue";
import MailSender from "@/components/pages/mail/MailSender.vue";
import Icon from "@/components/ds/icon/Icon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const uiStore = useUiStore();
const employeesStore = useEmployeeStore();
const documentsStore = useDocumentsStore();

const mail = ref<Mail | null>(null);
const watchActive = ref(false);

const atBack = () => {
    if (document.value) {
        const slug = documentToSlug(document.value);
        const prefix = document.value.doctype;
        router.push({ name: "Document", params: { prefix, slug } });
    }
};

const debouncedFn = useDebounceFn(() => {
    if (mail.value) {
        api.update(mail.value, "mails").then(() => {
            uiStore.message("Wijzigingen opgeslagen...");
        });
    }
}, 1000);

const document = computed(() => {
    return documentsStore.getItemById(mail.value?.documentId || 0);
});

const employee = computed(() => {
    return employeesStore.getItemById(mail.value?.user_id || 0);
});

const canEdit = computed(() => {
    return (
        mail.value &&
        !mail.value.sent &&
        uiStore.user?.id === mail.value.user_id
    );
});

watch(
    () => mail.value,
    () => {
        if (watchActive.value) {
            debouncedFn();
        }
    },
    { deep: true }
);

onMounted(() => {
    const id = Number(route.params.id);
    const m = documentsStore.getMailById(id);
    if (m) {
        mail.value = m;
        setTimeout(() => {
            watchActive.value = true;
        });
    }
});

return (_ctx: any,_cache: any) => {
  return (mail.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(NavigateBack, { onClick: atBack }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" Terug naar factuur ")
          ])),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          (mail.value.sent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(Icon, { "icon-id": "check" })
                ]),
                _cache[1] || (_cache[1] = _createTextVNode(" Deze mail is verzonden. "))
              ]))
            : _createCommentVNode("", true),
          (!canEdit.value && !mail.value.sent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Je kunt deze mail niet bewerken "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(MailSender, {
                  mail: mail.value,
                  employee: employee.value
                }, null, 8, ["mail", "employee"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(MailReceiver, {
                  mail: mail.value,
                  "can-edit": canEdit.value
                }, null, 8, ["mail", "can-edit"])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(MailSubject, {
                  mail: mail.value,
                  "can-edit": canEdit.value
                }, null, 8, ["mail", "can-edit"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(MailContent, {
                mail: mail.value,
                employee: employee.value,
                "can-edit": canEdit.value
              }, null, 8, ["mail", "employee", "can-edit"])
            ]),
            (document.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(MailAttachement, { document: document.value }, null, 8, ["document"])
                ]))
              : _createCommentVNode("", true)
          ]),
          (!mail.value.sent && canEdit.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(MailSend, { mail: mail.value }, null, 8, ["mail"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})